import React from "react";
import timelapsed from "timelapsed";

function TransxTable({ transactions }) {
  return (
    <div className="relative overflow-x-auto overflow-y-auto shadow-md sm:rounded-lg mt-12">
      <table className="w-full text-sm text-left text-gray-500 ">
        <thead className="text-xs text-gray-700 uppercase bg-yellow-100 ">
          <tr>
            <th scope="col" className="px-6 py-3">
              App
            </th>
            <th scope="col" className="px-6 py-3">
              Amount
            </th>
            <th scope="col" className="px-6 py-3">
              Paid By
            </th>
            <th scope="col" className="px-6 py-3">
              refference
            </th>
            <th scope="col" className="px-6 py-3">
              When
            </th>
          </tr>
        </thead>
        <tbody>
          {transactions.length < 1 ? (
            <tr className="bg-yellow-50 border-b hover:bg-yellow-50 ">
              <th
                scope="row"
                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
              >
                No Payments
              </th>
            </tr>
          ) : (
            transactions.map((item) => (
              <tr
                className="bg-yellow-50 border-b hover:bg-yellow-50"
                key={item._id}
              >
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                >
                  {item.app.name}
                </th>

                <td className="px-6 py-4">{item.amount}</td>
                <td className="px-6 py-4">{item.phone}</td>
                <td className="px-6 py-4">{item.mpesa_code}</td>
                <td className="px-6 py-4">
                  {timelapsed.fromDateString(item.createdAt)}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TransxTable;
